/** The wizard's steps, in order. The title bar, the rail and the footer's
 * "Continue to …" all index into this, so they can't drift apart. */
export const STEP_LABELS = [
  'Choose Type',
  'Basics',
  'Add files',
  'Tools',
  'Job details',
  'License',
  'Submit for Review',
] as const;

export type UploadStepLabel = (typeof STEP_LABELS)[number];
